'use client'

import type React from 'react'

type ProductAvailabilityProps = {
  title: string | React.ReactElement
  TitleIcon: React.ReactNode
  children: React.ReactNode
  isTitleVisible?: boolean
}

export function ProductAvailability({
  title,
  TitleIcon,
  isTitleVisible,
  children,
}: ProductAvailabilityProps) {
  if (!isTitleVisible) {
    return children
  }

  return (
    <div>
      <div className="flex items-center gap-0.5">
        {TitleIcon}
        <span className="text-lg font-bold leading-light text-brand-2-900">{title}</span>
      </div>

      <div className="flex flex-col gap-x-1">{children}</div>
    </div>
  )
}
